import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/chevronDown.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...n,
	children: [/* @__PURE__ */ e("g", {
		clipPath: "url(#clip0_779_146)",
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			d: "M14.05 3.923 8.201 9.766a.286.286 0 0 1-.404 0L1.95 3.923A1.143 1.143 0 1 0 .335 5.536l6.452 6.452a1.716 1.716 0 0 0 2.426 0l6.452-6.452a1.144 1.144 0 0 0-.797-1.989 1.14 1.14 0 0 0-.819.376"
		})
	}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
		id: "clip0_779_146",
		children: /* @__PURE__ */ e("rect", {
			width: 16,
			height: 16,
			fill: "#fff"
		})
	}) })]
});
//#endregion
export { n as default };
